module.exports = __webpack_public_path__ + "static/img/certificat_C.65d3350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificat_C.png
// module id = VMHP
// module chunks = 0